import React from 'react';
import { Container, Accordion, Card, Badge } from 'react-bootstrap';
import AppHeader from '../../components/Common/AppHeader';
import AppFooter from '../../components/Common/AppFooter';

const steps = [
  {
    title: "Step 1: Program Creation (Admin)",
    content: [
      "The Admin creates a Program representing a degree, certification, or academic offering.",
      "This acts as the top-level structure for managing courses and academic workflows."
    ]
  },
  {
    title: "Step 2: Project Setup & SME Assignment (Admin)",
    content: [
      "A Project is created within the Program for a specific course or subject.",
      "A Subject Matter Expert (SME) is assigned to manage academic content and validation."
    ]
  },
  {
    title: "Step 3: Curriculum Definition (SME)",
    content: [
      "The SME defines Modules, Units, and Topics.",
      "A well-structured curriculum is critical for high-quality content generation.",
      "The SME selects the appropriate Content and Taxonomy Standards."
    ]
  },
  {
    title: "Step 4: Reference Material Selection (SME)",
    content: [
      "Select 2–3 authoritative textbooks aligned with the curriculum.",
      "Recommended to use books under 1000 pages for optimal AI grounding.",
      "These act as the primary knowledge source for the system."
    ]
  },
  {
    title: "Step 5: Curriculum Mapping & Orchestration Start (SME)",
    content: [
      "The SME validates and finalizes the curriculum structure.",
      "Orchestration is initiated to begin the structured generation pipeline.",
      "Content is typically generated one unit at a time for better quality control."
    ]
  },
  {
    title: "Step 6: Concept Knowledge Base (CKB) Generation (System)",
    content: [
      "The system extracts concepts from reference materials.",
      "Each concept is mapped to source content and assigned cognitive levels.",
      "This forms the foundation for grounded and structured content generation."
    ]
  },
  {
    title: "Step 7: Content Generation (System)",
    content: [
      "The system generates instructional content aligned with the selected Content Standard.",
      "Each unit includes learning objectives, concept explanations, examples, and summaries.",
      "Content follows a consistent pedagogical structure."
    ]
  },
  {
    title: "Step 8: Assessment & Teaching Materials (System)",
    content: [
      "Assessments are generated based on blueprint configuration and taxonomy alignment.",
      "Teaching materials such as lecture notes and presentations are also created.",
      "Coverage across all concepts and learning outcomes is ensured."
    ]
  },
  {
    title: "Step 9: Packaging & Export",
    content: [
      "Content is compiled into structured formats such as DOCX, PDF, or LMS-ready outputs.",
      "Formatting, figures, and references are consolidated.",
      "The output is prepared for academic delivery."
    ]
  },
  {
    title: "Step 10: SME Review & Enhancement",
    content: [
      "The SME reviews content for accuracy, completeness, and contextual relevance.",
      "Institutional examples, case studies, and domain-specific insights can be added.",
      "This step ensures academic ownership and final quality assurance."
    ]
  }
];

const UserGuide = () => (
  <div className="bg-light min-vh-100 d-flex flex-column">
    <AppHeader />

    <Container className="py-5 flex-grow-1">
      <div className="text-center mb-5">
        <Badge bg="primary">AcademicOS Workflow Guide</Badge>
        <h1 className="fw-bold mt-2">End-to-End Content Development Workflow</h1>
        <p className="text-muted">
          A structured pipeline guiding academic teams from curriculum design to final content delivery.
        </p>
      </div>

      <Accordion defaultActiveKey="0">
        {steps.map((step, idx) => (
          <Accordion.Item eventKey={idx.toString()} key={idx}>
            <Accordion.Header>{step.title}</Accordion.Header>
            <Accordion.Body>
              {step.content.map((item, i) => (
                <Card key={i} className="mb-2 border-0 bg-light">
                  <Card.Body>{item}</Card.Body>
                </Card>
              ))}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </Container>

    <AppFooter />
  </div>
);

export default UserGuide;
